module.exports = __webpack_public_path__ + "media/sensor-details.b6de7848.mp4";